import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Money, DateTime } from '../../../components/Formatters';
import { Table, Thead, Tbody, Tr, LinkTr, Th, Td } from '../../../components/Table/Fake';
import { ListGap } from '../../../components/Paging';
import { getListKey } from '../../../helpers/paging';

import { DraftOrGap } from '../types';
import { DraftOrder } from '../../../types/orders';
import { isDraftOrder } from '../helpers';

interface RowProps extends WithTranslation {
    row: DraftOrGap;
    accountId: string;
    fillGap: (id: string) => void;
}

const Row = (
    {
        row,
        accountId,
        fillGap,
        t,
    }: RowProps
) => {
    if (isDraftOrder(row)) {
        const draft = row as DraftOrder;
        return (
            <LinkTr key={row.id} to={`/${accountId}/orders/drafts/${row.id}`} className="stop-borders-before-edges">
                <Td className="edge" />
                <Td className="first-child ellipsis"> {draft.id}</Td>
                <Td className="ellipsis">{(draft.order.customer && draft.order.customer.id) || 'N/A'}</Td>
                <Td>
                    <DateTime isoString={row.created_at || ''} boldTime />
                </Td>
                <Td>{t(`orders.order.status.${draft.status}`)}</Td>
                <Td className="last-child align-right">
                    <Money amount={draft.order.net_amount || 0} currency={draft.order.currency} boldCurrency />
                </Td>
                <Td className="edge" />
            </LinkTr>
        );
    } else {
        return <ListGap fillGap={fillGap} gap={row} label={t('orders.orders.load_gap')} />;
    }
};

const TranslatedRow = withTranslation()(Row);

export interface DraftsTableProps extends WithTranslation {
    drafts: DraftOrGap[];
    accountId: string;
    fillGap: (id: string) => void;
}

const DraftsTable = (
    {
        drafts,
        accountId,
        fillGap,
        t,
    }: DraftsTableProps
) => {
    return (
        <Table className="no-wrap">
            <Thead>
                <Tr>
                    <Th className="edge" />
                    <Th className="first-child">{t('orders.fields.id')}</Th>
                    <Th>{t('orders.fields.customer.header')}</Th>
                    <Th>{t('orders.fields.date')}</Th>
                    <Th>{t('orders.fields.status')}</Th>
                    <Th className="last-child">{t('orders.fields.amount')}</Th>
                    <Th className="edge" />
                </Tr>
            </Thead>
            {drafts.length > 0 && (
                <Tbody>
                    {drafts.map((draft) => (
                        <TranslatedRow key={getListKey(draft)} row={draft} accountId={accountId} fillGap={fillGap} />
                    ))}
                </Tbody>
            )}
        </Table>
    );
};

export default withTranslation()(DraftsTable);
